const { sha512 } = require('./../../tools/hash')

module.exports = cancelDebit
async function cancelDebit (cancelDebitOptions) {
  const {mandateId, requestId, transactionRef} = cancelDebitOptions
  const {merchantId, apiKey} = this

  const headers = {
    'Content-Type': 'application/json'
  }

  const hash = await sha512(`${transactionRef}${merchantId}${requestId}${apiKey}`)
  const body = {
    'merchantId': merchantId,
    'mandateId': mandateId,
    'hash': hash,
    'requestId': requestId,
    'transactionRef': transactionRef
  }

  return this.fetch(this.endpoints.cancelDebit, {
    method: 'POST',
    body: JSON.stringify(body),
    headers
  })
}
